import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import { getRequest, patchRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit, FaEye } from 'react-icons/fa';

const VideoList = () => {
  const [videoData, setVideoData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);

  const fetchVideos = async () => {
    try {
      const res = await getRequest('live-videos');
      setVideoData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch videos:', err);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const openModal = (video, viewOnly = false) => {
    setCurrentVideo(video);
    setIsViewMode(viewOnly);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!currentVideo?.id) return alert('Missing video ID!');

    const formData = new FormData();
    formData.append('youtube_url', currentVideo.youtube_url || '');
    formData.append('status', currentVideo.status || 'active');

    try {
      await patchRequest(`live-videos/${currentVideo.id}`, formData);
      fetchVideos();
      setShowModal(false);
    } catch (err) {
      console.error('Failed to update video:', err?.response?.data || err);
    }
  };

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this video?')) return;
    try {
      await deleteRequest(`live-videos/${id}`);
      fetchVideos();
    } catch (err) {
      console.error('Failed to delete video:', err);
    }
  };

  const tableHeaders = [
    { Header: 'YouTube URL', accessor: 'youtube_url' },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#17a2b8' }}
            onClick={() => openModal(row.original, true)}
          >
            <FaEye />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => openModal(row.original, false)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold">Video List</h4>
        </div>
        <div className="mx-4">
          {videoData?.length ? (
            <AdminTable tableHeaders={tableHeaders} tableData={videoData} />
          ) : (
            <p>No videos available.</p>
          )}
        </div>
      </div>

      {showModal && currentVideo && (
        <div className="modal fade show" style={{ display: 'block' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{isViewMode ? 'See All Details' : 'Update Video'}</h5>
                <button className="close" onClick={() => setShowModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                {isViewMode ? (
                  <>
                    {['youtube_url', 'status'].map((field) => (
                      <div className="form-group mb-2" key={field}>
                        <label htmlFor={field} className="admin-label">
                          {field.replace('_', ' ')}
                        </label>
                        <input
                          id={field}
                          type="text"
                          className="form-control"
                          value={currentVideo[field] || ''}
                          readOnly
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-md-8 mb-3">
                        <label htmlFor="youtube_url" className="admin-label">Youtube URL</label>
                        <input
                          id="youtube_url"
                          type="url"
                          className="form-control"
                          value={currentVideo.youtube_url || ''}
                          onChange={(e) => setCurrentVideo({ ...currentVideo, youtube_url: e.target.value })}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="status" className="admin-label">Status</label>
                        <select
                          id="status"
                          className="form-control"
                          value={currentVideo.status || 'active'}
                          onChange={(e) => setCurrentVideo({ ...currentVideo, status: e.target.value })}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                {!isViewMode && (
                  <button className="btn addbtn" onClick={handleSave}>
                    Save Changes
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoList;
